import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-2">{contactData.title}</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10 max-w-[600px] mx-auto">
          {contactData.description}
        </p>
        <div className="max-w-[700px] mx-auto">
          <div className="flex flex-col sm:flex-row items-stretch gap-4 md:gap-5 mb-6">
            {contactData.methods.map((m) => (
              <div key={m.label} className="flex-1 flex items-center gap-3 p-4 rounded-lg bg-background-100 border border-background-200">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${m.icon} text-lg text-primary-600`}></i>
                </div>
                <div className="min-w-0">
                  <span className="text-xs text-foreground-400 block">{m.label}</span>
                  <span className="text-sm font-semibold text-foreground-800 break-all">{m.value}</span>
                </div>
              </div>
            ))}
          </div>
          <p className="text-xs text-foreground-400 text-center">{contactData.disclaimer}</p>
        </div>
      </div>
    </section>
  );
}